var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Row, Col, Accordion } from "@folio/stripes/components";
import { useIntl } from "react-intl";
import { Controller } from "react-hook-form";
import { RecekTextArea, RecekTextField } from "./inputs";
export var LegalPersonGeneralFields = function (_a) {
    var control = _a.control, errors = _a.errors, _b = _a.compact, compact = _b === void 0 ? false : _b;
    var formatMessage = useIntl().formatMessage;
    // Optional for legal persons (DB-495): sent to NK authorities as MARC 678
    // without indicators only when filled.
    var biographicalNoteRow = (React.createElement(Row, null,
        React.createElement(Col, { xs: 12 },
            React.createElement(Controller, { control: control, name: "biographicalNote", render: function (_a) {
                    var _b;
                    var field = _a.field, fieldState = _a.fieldState;
                    return (React.createElement(RecekTextArea, __assign({}, field, { labelId: "ui-br-agency.legal-person.biographicalNote.field.label", error: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message, fullWidth: true })));
                } }))));
    if (compact) {
        return (React.createElement(React.Fragment, null,
            React.createElement(Row, null,
                React.createElement(Col, { xs: 12 },
                    React.createElement(Controller, { control: control, name: "name", render: function (_a) {
                            var _b;
                            var field = _a.field, fieldState = _a.fieldState;
                            return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-agency.legal-person.name.field.label", error: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message, required: true })));
                        } }))),
            biographicalNoteRow));
    }
    return (React.createElement(Accordion, { label: formatMessage({
            id: "ui-br-agency.legal-person.accordions.label.general",
        }), separator: false },
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12 },
                React.createElement(Controller, { control: control, name: "name", render: function (_a) {
                        var _b;
                        var field = _a.field, fieldState = _a.fieldState;
                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-agency.legal-person.name.field.label", error: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message, required: true })));
                    } }))),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12 },
                React.createElement(Controller, { control: control, name: "residence", render: function (_a) {
                        var _b;
                        var field = _a.field;
                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-agency.legal-person.residence.field.label", error: (_b = errors === null || errors === void 0 ? void 0 : errors.residence) === null || _b === void 0 ? void 0 : _b.message })));
                    } }))),
        biographicalNoteRow));
};
